import { render } from "./BankAccounts.vue?vue&type=template&id=b7499c84&scoped=true"
import script from "./BankAccounts.vue?vue&type=script&lang=js"
export * from "./BankAccounts.vue?vue&type=script&lang=js"

import "./BankAccounts.vue?vue&type=style&index=0&id=b7499c84&scoped=true&lang=css"

import exportComponent from "D:\\AppDev\\__\\_goblinbank\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b7499c84"]])

export default __exports__